import './IconButton.css'
import React from 'react'
import classNames from 'classnames'

type Props = {
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  type?: "button" | "submit";
  className?: string | string[];
  children: React.ReactNode;
}

export default function IconButton({ onClick, type, className, children  }: Props) {
  return (
    <button
      onClick={onClick}
      type={type}
      className={
        classNames([
          'icon-button',
          className
        ])
      }>{children}</button>
  )
}
